import {APP_INITIALIZER, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from 'projects/admin/src/app/components/app/app.component';
import {CommonModule} from '@angular/common';
import {BrowserAnimationsModule, NoopAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PipesModule} from 'projects/library/src/pipes/pipes.module';
import {MatCommonModule} from '@angular/material/core';
import {MatChipsModule} from '@angular/material/chips';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatMenuModule} from '@angular/material/menu';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatListModule} from '@angular/material/list';
import {MatTabsModule} from '@angular/material/tabs';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatTableModule} from '@angular/material/table';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatIconModule} from '@angular/material/icon';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTreeModule} from '@angular/material/tree';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {AngularSplitModule} from 'angular-split';
import {ConfigService} from 'projects/library/src/services/config/config.service';
import {ErrorService} from 'projects/library/src/services/error/error.service';
import {HttpLoaderService} from 'projects/library/src/services/http-loader/http-loader.service';
import {JsonService} from 'projects/library/src/services/json/json.service';
import {LanguageService} from 'projects/library/src/services/language/language.service';
import {LoggerService} from 'projects/library/src/services/logger/logger.service';
import {NavigationService} from 'projects/library/src/services/navigation/navigation.service';
import {RoutingModule} from 'projects/admin/src/routing.module';
import {preloadFactory} from 'projects/library/src/bootstrap/preload-factory';
import {LoginComponent} from 'projects/admin/src/app/components/login/login.component';
import { LocationComponent } from './components/location/location.component';
import { ListEditorComponent } from './components/list-editor/list-editor.component';
import { LocationImageEditorComponent } from './components/location-image-editor/location-image-editor.component';
import { LocationUserEditorComponent } from './components/location-user-editor/location-user-editor.component';
import { LocationItemEditorComponent } from './components/location-item-editor/location-item-editor.component';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { HelpComponent } from './components/help/help.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LocationComponent,
    ListEditorComponent,
    LocationImageEditorComponent,
    LocationUserEditorComponent,
    LocationItemEditorComponent,
    LanguageSelectorComponent,
    HelpComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule,
    RoutingModule,
    FormsModule,
    PipesModule,

    // Material modules
    MatCommonModule,
    MatChipsModule,
    MatToolbarModule,
    MatMenuModule,
    NoopAnimationsModule,
    MatSidenavModule,
    MatDialogModule,
    MatSnackBarModule,
    MatBottomSheetModule,
    MatListModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    FormsModule,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatRadioModule,
    MatDatepickerModule,
    MatIconModule,
    MatExpansionModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatTreeModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatSlideToggleModule,
    AngularSplitModule,
    // AngularSplitModule.forRoot(),
  ],
  providers: [
    ConfigService,
    ErrorService,
    HttpLoaderService,
    JsonService,
    LanguageService,
    LoggerService,
    NavigationService,
    { provide: APP_INITIALIZER , useFactory: preloadFactory, deps: [JsonService], multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
